import { ResponseObject } from "@/app/classes/main";
import { ApiService } from "@/app/services/AppService";
import { Box, Button, Dialog, IconButton, Slide } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import Image from "next/image";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

const dialogStyles = {
  width: "100%",
  height: "100%",
  maxHeight: "100%",
  maxWidth: "800px",
  overflow: "scroll",
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface GuideProps {
  serviceId: any;
}

interface GuideStepsImagesProps {
  file: {
    secureHttpPath: string;
  };
}

export const Guide: React.FC<GuideProps> = ({ serviceId }) => {
  const [openGuide, setOpenGuide] = useState(false);
  const [guideStepsImages, setGuideStepsImages] = useState<
    GuideStepsImagesProps[] | []
  >([]);
  const apiService = new ApiService();

  const handleGuideData = async () => {
    try {
      if (serviceId) {
        const responseObject: ResponseObject | undefined =
          await apiService.get<ResponseObject>(
            apiService.serviceGuideSteps + serviceId
          );
        const response = responseObject?.object;
        setGuideStepsImages(response);
        setOpenGuide(true);
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        color="success"
        sx={{
          color: "#15741a",
          textTransform: "capitalize",
          padding: "0px",
          fontSize: "12px",
        }}
        onClick={handleGuideData}
      >
        Guide
      </Button>
      <Dialog
        fullScreen
        PaperProps={{
          style: {
            ...dialogStyles,
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          },
        }}
        open={openGuide}
        onClose={() => setOpenGuide(false)}
        TransitionComponent={Transition}
        className="scroll-bar"
      >
        <Box
          sx={{
            position: "relative",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              width: "-webkit-fill-available",
              position: "absolute",
            }}
          >
            <IconButton onClick={() => setOpenGuide(false)}>
              <CloseIcon
                sx={{
                  background: "#15741a",
                  padding: "4px",
                  fontSize: "24px",
                  cursor: "pointer",
                  color: "white",
                  width: "30px",
                  height: "30px",
                  borderRadius: "100%",
                }}
              />
            </IconButton>
          </Box>
          <Box>
            {guideStepsImages?.map((item: any, index: any) => (
              <Image
                key={index}
                src={item?.file?.secureHttpPath}
                priority={true}
                alt={`Banner ${index + 1}`}
                style={{
                  width: "100%",
                  margin: "auto",
                  height: "auto",
                  objectFit: "contain",
                  display: "block",
                }}
                height={2000}
                width={3000}
              />
            ))}
          </Box>
        </Box>
      </Dialog>
    </>
  );
};
